/**
 * Generato automaticamente.
 * OpenAPI
 */
import { useMutation, useQuery } from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient.ts';
import type { ErrorType } from '../../../client/apiClient.ts';
import type { AreeDTO } from '../schemas/areeDTO.ts';
import type { BEResponseString } from '../schemas/bEResponseString.ts';
import type { CampoEstraibileCSV } from '../schemas/campoEstraibileCSV.ts';
import type { Competenza } from '../schemas/competenza.ts';
import type { ConfrontoVersioniResponse } from '../schemas/confrontoVersioniResponse.ts';
import type { GetTipiDomandaB2BSearchParams } from '../schemas/getTipiDomandaB2BSearchParams.ts';
import type { GetTipiDomandaByIdsGruppiInCollaudoParams } from '../schemas/getTipiDomandaByIdsGruppiInCollaudoParams.ts';
import type { GetTipiDomandaDifferenzeVersioniParams } from '../schemas/getTipiDomandaDifferenzeVersioniParams.ts';
import type { GetTipiDomandaIdCampiGeojsonParams } from '../schemas/getTipiDomandaIdCampiGeojsonParams.ts';
import type { GetTipiDomandaIdModuliParams } from '../schemas/getTipiDomandaIdModuliParams.ts';
import type { GetTipiDomandaIdTipoDomandaCompetenzeUfficiParams } from '../schemas/getTipiDomandaIdTipoDomandaCompetenzeUfficiParams.ts';
import type { GetTipiDomandaModuliSezioniParams } from '../schemas/getTipiDomandaModuliSezioniParams.ts';
import type { GetTipiDomandaParams } from '../schemas/getTipiDomandaParams.ts';
import type { ModuloDTO } from '../schemas/moduloDTO.ts';
import type { ModuloRequest } from '../schemas/moduloRequest.ts';
import type { PostTipiDomandaByIdsGruppiB2BParams } from '../schemas/postTipiDomandaByIdsGruppiB2BParams.ts';
import type { PostTipiDomandaIdFilePubbliciBody } from '../schemas/postTipiDomandaIdFilePubbliciBody.ts';
import type { PostTipiDomandaIdInCollaudoParams } from '../schemas/postTipiDomandaIdInCollaudoParams.ts';
import type { PostTipiDomandaIdPubblicaParams } from '../schemas/postTipiDomandaIdPubblicaParams.ts';
import type { PutTipiDomandaIdTemplateRiepilogoBody } from '../schemas/putTipiDomandaIdTemplateRiepilogoBody.ts';
import type { StatoTraduzione } from '../schemas/statoTraduzione.ts';
import type { TipoDomandaDTO } from '../schemas/tipoDomandaDTO.ts';
import type { TipoDomandaDuplicaRequest } from '../schemas/tipoDomandaDuplicaRequest.ts';
import type { TipoDomandaModuloDTO } from '../schemas/tipoDomandaModuloDTO.ts';
import type { TipoDomandaModuloRequest } from '../schemas/tipoDomandaModuloRequest.ts';
import type { TipoDomandaModuloSezioneDTO } from '../schemas/tipoDomandaModuloSezioneDTO.ts';
import type { TipoDomandaRequest } from '../schemas/tipoDomandaRequest.ts';
import type { TipoDomandaRicevutaDTO } from '../schemas/tipoDomandaRicevutaDTO.ts';
import type { TipoDomandaRicevutaRequest } from '../schemas/tipoDomandaRicevutaRequest.ts';
import type { UfficioCompetenzaDTO } from '../schemas/ufficioCompetenzaDTO.ts';
import type { WsProblema } from '../schemas/wsProblema.ts';
import type { WsRispostaPaginataListTipoDomandaDTO } from '../schemas/wsRispostaPaginataListTipoDomandaDTO.ts';
import type { WsRispostaPaginataListTipoDomandaModuloDTO } from '../schemas/wsRispostaPaginataListTipoDomandaModuloDTO.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Ottiene i dettagli di una tipoDomanda.
 * @summary Dettaglio TipoDomanda
 */
export const getTipiDomandaId = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<TipoDomandaDTO>(
    { url: `/framework-cfg-domande/tipi-domanda/${id}`, method: 'get', signal },
    options,
  );
};

export const getGetTipiDomandaIdQueryKey = (id: string) =>
  [`/framework-cfg-domande/tipi-domanda/${id}`] as const;

export const getGetTipiDomandaIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiDomandaId>>,
  TError = ErrorType<WsProblema>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiDomandaId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTipiDomandaIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiDomandaId>>
  > = ({ signal }) => getTipiDomandaId(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetTipiDomandaIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiDomandaId>>
>;
export type GetTipiDomandaIdQueryError = ErrorType<WsProblema>;

/**
 * @summary Dettaglio TipoDomanda
 */
export const useGetTipiDomandaId = <
  TData = Awaited<ReturnType<typeof getTipiDomandaId>>,
  TError = ErrorType<WsProblema>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiDomandaIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Aggiorna una tipoDomanda.
 * @summary Modifica TipoDomanda
 */
export const putTipiDomandaId = (
  id: string,
  tipoDomandaRequest: TipoDomandaRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<TipoDomandaDTO>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: tipoDomandaRequest,
    },
    options,
  );
};

export const getPutTipiDomandaIdMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putTipiDomandaId>>,
    TError,
    { id: string; data: TipoDomandaRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putTipiDomandaId>>,
  TError,
  { id: string; data: TipoDomandaRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putTipiDomandaId>>,
    { id: string; data: TipoDomandaRequest }
  > = props => {
    const { id, data } = props ?? {};

    return putTipiDomandaId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutTipiDomandaIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putTipiDomandaId>>
>;
export type PutTipiDomandaIdMutationBody = TipoDomandaRequest;
export type PutTipiDomandaIdMutationError = ErrorType<WsProblema>;

/**
 * @summary Modifica TipoDomanda
 */
export const usePutTipiDomandaId = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putTipiDomandaId>>,
    TError,
    { id: string; data: TipoDomandaRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPutTipiDomandaIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Rimuove una tipoDomanda tramite cancellazione logica.
 * @summary Elimina TipoDomanda
 */
export const deleteTipiDomandaId = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    { url: `/framework-cfg-domande/tipi-domanda/${id}`, method: 'delete' },
    options,
  );
};

export const getDeleteTipiDomandaIdMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTipiDomandaId>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTipiDomandaId>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTipiDomandaId>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteTipiDomandaId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTipiDomandaIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTipiDomandaId>>
>;

export type DeleteTipiDomandaIdMutationError = ErrorType<WsProblema>;

/**
 * @summary Elimina TipoDomanda
 */
export const useDeleteTipiDomandaId = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTipiDomandaId>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getDeleteTipiDomandaIdMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Recupera il file template associato al TipoDomanda specificato.
 * @summary Scarica Template Riepilogo Richiesta
 */
export const getTipiDomandaIdTemplateRiepilogo = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<unknown>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}/template-riepilogo`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetTipiDomandaIdTemplateRiepilogoQueryKey = (id: string) =>
  [`/framework-cfg-domande/tipi-domanda/${id}/template-riepilogo`] as const;

export const getGetTipiDomandaIdTemplateRiepilogoQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiDomandaIdTemplateRiepilogo>>,
  TError = ErrorType<WsProblema>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaIdTemplateRiepilogo>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiDomandaIdTemplateRiepilogo>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTipiDomandaIdTemplateRiepilogoQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiDomandaIdTemplateRiepilogo>>
  > = ({ signal }) =>
    getTipiDomandaIdTemplateRiepilogo(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetTipiDomandaIdTemplateRiepilogoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiDomandaIdTemplateRiepilogo>>
>;
export type GetTipiDomandaIdTemplateRiepilogoQueryError = ErrorType<WsProblema>;

/**
 * @summary Scarica Template Riepilogo Richiesta
 */
export const useGetTipiDomandaIdTemplateRiepilogo = <
  TData = Awaited<ReturnType<typeof getTipiDomandaIdTemplateRiepilogo>>,
  TError = ErrorType<WsProblema>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaIdTemplateRiepilogo>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiDomandaIdTemplateRiepilogoQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Aggiorna una tipoDomanda aggiungendo/sostituendo il file template per il riepilogo della richiesta.
 * @summary Aggiungi Template Riepilogo Richiesta a TipoDomanda
 */
export const putTipiDomandaIdTemplateRiepilogo = (
  id: string,
  putTipiDomandaIdTemplateRiepilogoBody: PutTipiDomandaIdTemplateRiepilogoBody,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  const formData = new FormData();
  if (
    putTipiDomandaIdTemplateRiepilogoBody.fileTemplateRiepilogoRichiesta !==
    undefined
  ) {
    formData.append(
      'fileTemplateRiepilogoRichiesta',
      putTipiDomandaIdTemplateRiepilogoBody.fileTemplateRiepilogoRichiesta,
    );
  }

  return apiClientRequest<TipoDomandaDTO>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}/template-riepilogo`,
      method: 'put',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    },
    options,
  );
};

export const getPutTipiDomandaIdTemplateRiepilogoMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putTipiDomandaIdTemplateRiepilogo>>,
    TError,
    { id: string; data: PutTipiDomandaIdTemplateRiepilogoBody },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putTipiDomandaIdTemplateRiepilogo>>,
  TError,
  { id: string; data: PutTipiDomandaIdTemplateRiepilogoBody },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putTipiDomandaIdTemplateRiepilogo>>,
    { id: string; data: PutTipiDomandaIdTemplateRiepilogoBody }
  > = props => {
    const { id, data } = props ?? {};

    return putTipiDomandaIdTemplateRiepilogo(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutTipiDomandaIdTemplateRiepilogoMutationResult = NonNullable<
  Awaited<ReturnType<typeof putTipiDomandaIdTemplateRiepilogo>>
>;
export type PutTipiDomandaIdTemplateRiepilogoMutationBody =
  PutTipiDomandaIdTemplateRiepilogoBody;
export type PutTipiDomandaIdTemplateRiepilogoMutationError =
  ErrorType<WsProblema>;

/**
 * @summary Aggiungi Template Riepilogo Richiesta a TipoDomanda
 */
export const usePutTipiDomandaIdTemplateRiepilogo = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putTipiDomandaIdTemplateRiepilogo>>,
    TError,
    { id: string; data: PutTipiDomandaIdTemplateRiepilogoBody },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutTipiDomandaIdTemplateRiepilogoMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Rimuove il file template associato al TipoDomanda e pulisce il riferimento nel database.
 * @summary Elimina Template Riepilogo Richiesta
 */
export const deleteTipiDomandaIdTemplateRiepilogo = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}/template-riepilogo`,
      method: 'delete',
    },
    options,
  );
};

export const getDeleteTipiDomandaIdTemplateRiepilogoMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTipiDomandaIdTemplateRiepilogo>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTipiDomandaIdTemplateRiepilogo>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTipiDomandaIdTemplateRiepilogo>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return deleteTipiDomandaIdTemplateRiepilogo(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTipiDomandaIdTemplateRiepilogoMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTipiDomandaIdTemplateRiepilogo>>
>;

export type DeleteTipiDomandaIdTemplateRiepilogoMutationError =
  ErrorType<WsProblema>;

/**
 * @summary Elimina Template Riepilogo Richiesta
 */
export const useDeleteTipiDomandaIdTemplateRiepilogo = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTipiDomandaIdTemplateRiepilogo>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getDeleteTipiDomandaIdTemplateRiepilogoMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Ottiene la struttura della ricevuta della domanda. Di default è vuota.
 * @summary Get tipoDomanda ricevuta
 */
export const getTipiDomandaIdRicevuta = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<TipoDomandaRicevutaDTO>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}/ricevuta`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetTipiDomandaIdRicevutaQueryKey = (id: string) =>
  [`/framework-cfg-domande/tipi-domanda/${id}/ricevuta`] as const;

export const getGetTipiDomandaIdRicevutaQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiDomandaIdRicevuta>>,
  TError = ErrorType<WsProblema>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaIdRicevuta>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiDomandaIdRicevuta>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTipiDomandaIdRicevutaQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiDomandaIdRicevuta>>
  > = ({ signal }) => getTipiDomandaIdRicevuta(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetTipiDomandaIdRicevutaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiDomandaIdRicevuta>>
>;
export type GetTipiDomandaIdRicevutaQueryError = ErrorType<WsProblema>;

/**
 * @summary Get tipoDomanda ricevuta
 */
export const useGetTipiDomandaIdRicevuta = <
  TData = Awaited<ReturnType<typeof getTipiDomandaIdRicevuta>>,
  TError = ErrorType<WsProblema>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaIdRicevuta>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiDomandaIdRicevutaQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Modifica la struttura della ricevuta per il rispondente.
 * @summary Modifica tipoDomanda ricevuta
 */
export const putTipiDomandaIdRicevuta = (
  id: string,
  tipoDomandaRicevutaRequest: TipoDomandaRicevutaRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<TipoDomandaRicevutaDTO>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}/ricevuta`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: tipoDomandaRicevutaRequest,
    },
    options,
  );
};

export const getPutTipiDomandaIdRicevutaMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putTipiDomandaIdRicevuta>>,
    TError,
    { id: string; data: TipoDomandaRicevutaRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putTipiDomandaIdRicevuta>>,
  TError,
  { id: string; data: TipoDomandaRicevutaRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putTipiDomandaIdRicevuta>>,
    { id: string; data: TipoDomandaRicevutaRequest }
  > = props => {
    const { id, data } = props ?? {};

    return putTipiDomandaIdRicevuta(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutTipiDomandaIdRicevutaMutationResult = NonNullable<
  Awaited<ReturnType<typeof putTipiDomandaIdRicevuta>>
>;
export type PutTipiDomandaIdRicevutaMutationBody = TipoDomandaRicevutaRequest;
export type PutTipiDomandaIdRicevutaMutationError = ErrorType<WsProblema>;

/**
 * @summary Modifica tipoDomanda ricevuta
 */
export const usePutTipiDomandaIdRicevuta = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putTipiDomandaIdRicevuta>>,
    TError,
    { id: string; data: TipoDomandaRicevutaRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPutTipiDomandaIdRicevutaMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Ritorna l'elenco di tutti i moduli associati al tipoDomanda.
 * @summary Elenco Moduli di un TipoDomanda
 */
export const getTipiDomandaIdModuli = (
  id: string,
  params?: GetTipiDomandaIdModuliParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<WsRispostaPaginataListTipoDomandaModuloDTO>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}/moduli`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetTipiDomandaIdModuliQueryKey = (
  id: string,
  params?: GetTipiDomandaIdModuliParams,
) =>
  [
    `/framework-cfg-domande/tipi-domanda/${id}/moduli`,
    ...(params ? [params] : []),
  ] as const;

export const getGetTipiDomandaIdModuliQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiDomandaIdModuli>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetTipiDomandaIdModuliParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaIdModuli>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiDomandaIdModuli>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTipiDomandaIdModuliQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiDomandaIdModuli>>
  > = ({ signal }) =>
    getTipiDomandaIdModuli(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetTipiDomandaIdModuliQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiDomandaIdModuli>>
>;
export type GetTipiDomandaIdModuliQueryError = ErrorType<unknown>;

/**
 * @summary Elenco Moduli di un TipoDomanda
 */
export const useGetTipiDomandaIdModuli = <
  TData = Awaited<ReturnType<typeof getTipiDomandaIdModuli>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetTipiDomandaIdModuliParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaIdModuli>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiDomandaIdModuliQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Imposta il collegamento tra il tipoDomanda e i moduli (principale, secondari e dinamici). Il body deve contenere obbligatoriamente tutti i moduli coinvolti nella domanda, nell'ordine desiderato. L'ordinamento viene rispettato secondo la posizione nella lista.
 * @summary Crea collegamento TipoDomanda - lista Moduli
 */
export const putTipiDomandaIdModuli = (
  id: string,
  tipoDomandaModuloRequest: TipoDomandaModuloRequest[],
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<TipoDomandaModuloDTO[]>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}/moduli`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: tipoDomandaModuloRequest,
    },
    options,
  );
};

export const getPutTipiDomandaIdModuliMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putTipiDomandaIdModuli>>,
    TError,
    { id: string; data: TipoDomandaModuloRequest[] },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putTipiDomandaIdModuli>>,
  TError,
  { id: string; data: TipoDomandaModuloRequest[] },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putTipiDomandaIdModuli>>,
    { id: string; data: TipoDomandaModuloRequest[] }
  > = props => {
    const { id, data } = props ?? {};

    return putTipiDomandaIdModuli(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutTipiDomandaIdModuliMutationResult = NonNullable<
  Awaited<ReturnType<typeof putTipiDomandaIdModuli>>
>;
export type PutTipiDomandaIdModuliMutationBody = TipoDomandaModuloRequest[];
export type PutTipiDomandaIdModuliMutationError = ErrorType<WsProblema>;

/**
 * @summary Crea collegamento TipoDomanda - lista Moduli
 */
export const usePutTipiDomandaIdModuli = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putTipiDomandaIdModuli>>,
    TError,
    { id: string; data: TipoDomandaModuloRequest[] },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPutTipiDomandaIdModuliMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Crea un nuovo modulo associato alla domanda. Di conseguenza, crea anche la prima Versione del modulo.
 * @summary Crea Modulo
 */
export const postTipiDomandaIdModuli = (
  id: string,
  moduloRequest: ModuloRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<ModuloDTO>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}/moduli`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: moduloRequest,
    },
    options,
  );
};

export const getPostTipiDomandaIdModuliMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomandaIdModuli>>,
    TError,
    { id: string; data: ModuloRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTipiDomandaIdModuli>>,
  TError,
  { id: string; data: ModuloRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTipiDomandaIdModuli>>,
    { id: string; data: ModuloRequest }
  > = props => {
    const { id, data } = props ?? {};

    return postTipiDomandaIdModuli(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTipiDomandaIdModuliMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTipiDomandaIdModuli>>
>;
export type PostTipiDomandaIdModuliMutationBody = ModuloRequest;
export type PostTipiDomandaIdModuliMutationError = ErrorType<WsProblema>;

/**
 * @summary Crea Modulo
 */
export const usePostTipiDomandaIdModuli = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomandaIdModuli>>,
    TError,
    { id: string; data: ModuloRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostTipiDomandaIdModuliMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Crea un collegamento tra il tipoDomanda e il modulo passati nell'url
 * @summary Crea collegamento TipoDomanda - Modulo
 */
export const putTipiDomandaIdModuliIdModulo = (
  id: string,
  idModulo: string,
  tipoDomandaModuloRequest: TipoDomandaModuloRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<TipoDomandaModuloDTO>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}/moduli/${idModulo}`,
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      data: tipoDomandaModuloRequest,
    },
    options,
  );
};

export const getPutTipiDomandaIdModuliIdModuloMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putTipiDomandaIdModuliIdModulo>>,
    TError,
    { id: string; idModulo: string; data: TipoDomandaModuloRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putTipiDomandaIdModuliIdModulo>>,
  TError,
  { id: string; idModulo: string; data: TipoDomandaModuloRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putTipiDomandaIdModuliIdModulo>>,
    { id: string; idModulo: string; data: TipoDomandaModuloRequest }
  > = props => {
    const { id, idModulo, data } = props ?? {};

    return putTipiDomandaIdModuliIdModulo(id, idModulo, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutTipiDomandaIdModuliIdModuloMutationResult = NonNullable<
  Awaited<ReturnType<typeof putTipiDomandaIdModuliIdModulo>>
>;
export type PutTipiDomandaIdModuliIdModuloMutationBody =
  TipoDomandaModuloRequest;
export type PutTipiDomandaIdModuliIdModuloMutationError = ErrorType<WsProblema>;

/**
 * @summary Crea collegamento TipoDomanda - Modulo
 */
export const usePutTipiDomandaIdModuliIdModulo = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putTipiDomandaIdModuliIdModulo>>,
    TError,
    { id: string; idModulo: string; data: TipoDomandaModuloRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutTipiDomandaIdModuliIdModuloMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Scollega il tipoDomanda e il modulo passati nell'url
 * @summary Scollega TipoDomanda - Modulo
 */
export const deleteTipiDomandaIdModuliIdModulo = (
  id: string,
  idModulo: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}/moduli/${idModulo}`,
      method: 'delete',
    },
    options,
  );
};

export const getDeleteTipiDomandaIdModuliIdModuloMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTipiDomandaIdModuliIdModulo>>,
    TError,
    { id: string; idModulo: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTipiDomandaIdModuliIdModulo>>,
  TError,
  { id: string; idModulo: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTipiDomandaIdModuliIdModulo>>,
    { id: string; idModulo: string }
  > = props => {
    const { id, idModulo } = props ?? {};

    return deleteTipiDomandaIdModuliIdModulo(id, idModulo, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTipiDomandaIdModuliIdModuloMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTipiDomandaIdModuliIdModulo>>
>;

export type DeleteTipiDomandaIdModuliIdModuloMutationError =
  ErrorType<WsProblema>;

/**
 * @summary Scollega TipoDomanda - Modulo
 */
export const useDeleteTipiDomandaIdModuliIdModulo = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTipiDomandaIdModuliIdModulo>>,
    TError,
    { id: string; idModulo: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getDeleteTipiDomandaIdModuliIdModuloMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Ritorna l'elenco delle tipoDomande.
 * @summary Elenco TipoDomande
 */
export const getTipiDomanda = (
  params?: GetTipiDomandaParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<WsRispostaPaginataListTipoDomandaDTO>(
    {
      url: `/framework-cfg-domande/tipi-domanda`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetTipiDomandaQueryKey = (params?: GetTipiDomandaParams) =>
  [`/framework-cfg-domande/tipi-domanda`, ...(params ? [params] : [])] as const;

export const getGetTipiDomandaQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiDomanda>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTipiDomandaParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomanda>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiDomanda>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTipiDomandaQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTipiDomanda>>> = ({
    signal,
  }) => getTipiDomanda(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetTipiDomandaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiDomanda>>
>;
export type GetTipiDomandaQueryError = ErrorType<unknown>;

/**
 * @summary Elenco TipoDomande
 */
export const useGetTipiDomanda = <
  TData = Awaited<ReturnType<typeof getTipiDomanda>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTipiDomandaParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomanda>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiDomandaQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Crea una nuova tipoDomanda a partire dal body fornito.
 * @summary Crea TipoDomanda
 */
export const postTipiDomanda = (
  tipoDomandaRequest: TipoDomandaRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<TipoDomandaDTO>(
    {
      url: `/framework-cfg-domande/tipi-domanda`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: tipoDomandaRequest,
    },
    options,
  );
};

export const getPostTipiDomandaMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomanda>>,
    TError,
    { data: TipoDomandaRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTipiDomanda>>,
  TError,
  { data: TipoDomandaRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTipiDomanda>>,
    { data: TipoDomandaRequest }
  > = props => {
    const { data } = props ?? {};

    return postTipiDomanda(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTipiDomandaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTipiDomanda>>
>;
export type PostTipiDomandaMutationBody = TipoDomandaRequest;
export type PostTipiDomandaMutationError = ErrorType<WsProblema>;

/**
 * @summary Crea TipoDomanda
 */
export const usePostTipiDomanda = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomanda>>,
    TError,
    { data: TipoDomandaRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostTipiDomandaMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Modifica lo stato della tipoDomanda, pubblicandola
 * @summary Pubblica il TipoDomanda
 */
export const postTipiDomandaIdPubblica = (
  id: string,
  params?: PostTipiDomandaIdPubblicaParams,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<TipoDomandaDTO>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}/pubblica`,
      method: 'post',
      params,
    },
    options,
  );
};

export const getPostTipiDomandaIdPubblicaMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomandaIdPubblica>>,
    TError,
    { id: string; params?: PostTipiDomandaIdPubblicaParams },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTipiDomandaIdPubblica>>,
  TError,
  { id: string; params?: PostTipiDomandaIdPubblicaParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTipiDomandaIdPubblica>>,
    { id: string; params?: PostTipiDomandaIdPubblicaParams }
  > = props => {
    const { id, params } = props ?? {};

    return postTipiDomandaIdPubblica(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTipiDomandaIdPubblicaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTipiDomandaIdPubblica>>
>;

export type PostTipiDomandaIdPubblicaMutationError = ErrorType<WsProblema>;

/**
 * @summary Pubblica il TipoDomanda
 */
export const usePostTipiDomandaIdPubblica = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomandaIdPubblica>>,
    TError,
    { id: string; params?: PostTipiDomandaIdPubblicaParams },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostTipiDomandaIdPubblicaMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Modifica lo stato della tipoDomanda, pubblicandola in collaudo e creando una nuova versione.
 * @summary Pubblica il TipoDomanda in collaudo
 */
export const postTipiDomandaIdPromuovi = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<TipoDomandaDTO>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}/promuovi`,
      method: 'post',
    },
    options,
  );
};

export const getPostTipiDomandaIdPromuoviMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomandaIdPromuovi>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTipiDomandaIdPromuovi>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTipiDomandaIdPromuovi>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return postTipiDomandaIdPromuovi(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTipiDomandaIdPromuoviMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTipiDomandaIdPromuovi>>
>;

export type PostTipiDomandaIdPromuoviMutationError = ErrorType<WsProblema>;

/**
 * @summary Pubblica il TipoDomanda in collaudo
 */
export const usePostTipiDomandaIdPromuovi = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomandaIdPromuovi>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostTipiDomandaIdPromuoviMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Aggiorna e restituisce il progressivo richiesta per un tipo domanda.
 * @summary Nuovo progressivo richiesta
 */
export const postTipiDomandaIdNextVal = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<TipoDomandaDTO>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}/next-val`,
      method: 'post',
    },
    options,
  );
};

export const getPostTipiDomandaIdNextValMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomandaIdNextVal>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTipiDomandaIdNextVal>>,
  TError,
  { id: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTipiDomandaIdNextVal>>,
    { id: string }
  > = props => {
    const { id } = props ?? {};

    return postTipiDomandaIdNextVal(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTipiDomandaIdNextValMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTipiDomandaIdNextVal>>
>;

export type PostTipiDomandaIdNextValMutationError = ErrorType<unknown>;

/**
 * @summary Nuovo progressivo richiesta
 */
export const usePostTipiDomandaIdNextVal = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomandaIdNextVal>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostTipiDomandaIdNextValMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Modifica lo stato della tipoDomanda, pubblicandola in collaudo e creando una nuova versione.
 * @summary Pubblica il TipoDomanda in collaudo
 */
export const postTipiDomandaIdInCollaudo = (
  id: string,
  params?: PostTipiDomandaIdInCollaudoParams,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<TipoDomandaDTO>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}/in-collaudo`,
      method: 'post',
      params,
    },
    options,
  );
};

export const getPostTipiDomandaIdInCollaudoMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomandaIdInCollaudo>>,
    TError,
    { id: string; params?: PostTipiDomandaIdInCollaudoParams },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTipiDomandaIdInCollaudo>>,
  TError,
  { id: string; params?: PostTipiDomandaIdInCollaudoParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTipiDomandaIdInCollaudo>>,
    { id: string; params?: PostTipiDomandaIdInCollaudoParams }
  > = props => {
    const { id, params } = props ?? {};

    return postTipiDomandaIdInCollaudo(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTipiDomandaIdInCollaudoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTipiDomandaIdInCollaudo>>
>;

export type PostTipiDomandaIdInCollaudoMutationError = ErrorType<WsProblema>;

/**
 * @summary Pubblica il TipoDomanda in collaudo
 */
export const usePostTipiDomandaIdInCollaudo = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomandaIdInCollaudo>>,
    TError,
    { id: string; params?: PostTipiDomandaIdInCollaudoParams },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostTipiDomandaIdInCollaudoMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Carica un file in multipart e ne ritorna il percorso salvato nello storage.
 * @summary Carica file pubblico
 */
export const postTipiDomandaIdFilePubblici = (
  id: string,
  postTipiDomandaIdFilePubbliciBody: PostTipiDomandaIdFilePubbliciBody,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  const formData = new FormData();
  formData.append('file', postTipiDomandaIdFilePubbliciBody.file);

  return apiClientRequest<BEResponseString>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}/file-pubblici`,
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    },
    options,
  );
};

export const getPostTipiDomandaIdFilePubbliciMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomandaIdFilePubblici>>,
    TError,
    { id: string; data: PostTipiDomandaIdFilePubbliciBody },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTipiDomandaIdFilePubblici>>,
  TError,
  { id: string; data: PostTipiDomandaIdFilePubbliciBody },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTipiDomandaIdFilePubblici>>,
    { id: string; data: PostTipiDomandaIdFilePubbliciBody }
  > = props => {
    const { id, data } = props ?? {};

    return postTipiDomandaIdFilePubblici(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTipiDomandaIdFilePubbliciMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTipiDomandaIdFilePubblici>>
>;
export type PostTipiDomandaIdFilePubbliciMutationBody =
  PostTipiDomandaIdFilePubbliciBody;
export type PostTipiDomandaIdFilePubbliciMutationError = ErrorType<unknown>;

/**
 * @summary Carica file pubblico
 */
export const usePostTipiDomandaIdFilePubblici = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomandaIdFilePubblici>>,
    TError,
    { id: string; data: PostTipiDomandaIdFilePubbliciBody },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostTipiDomandaIdFilePubbliciMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Crea una copia duplicata di una tipoDomanda attualmente esistente.
 * @summary Duplica TipoDomanda
 */
export const postTipiDomandaIdAzioniDuplica = (
  id: string,
  tipoDomandaDuplicaRequest: TipoDomandaDuplicaRequest,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<TipoDomandaDTO>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}/azioni/duplica`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: tipoDomandaDuplicaRequest,
    },
    options,
  );
};

export const getPostTipiDomandaIdAzioniDuplicaMutationOptions = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomandaIdAzioniDuplica>>,
    TError,
    { id: string; data: TipoDomandaDuplicaRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTipiDomandaIdAzioniDuplica>>,
  TError,
  { id: string; data: TipoDomandaDuplicaRequest },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTipiDomandaIdAzioniDuplica>>,
    { id: string; data: TipoDomandaDuplicaRequest }
  > = props => {
    const { id, data } = props ?? {};

    return postTipiDomandaIdAzioniDuplica(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTipiDomandaIdAzioniDuplicaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTipiDomandaIdAzioniDuplica>>
>;
export type PostTipiDomandaIdAzioniDuplicaMutationBody =
  TipoDomandaDuplicaRequest;
export type PostTipiDomandaIdAzioniDuplicaMutationError = ErrorType<WsProblema>;

/**
 * @summary Duplica TipoDomanda
 */
export const usePostTipiDomandaIdAzioniDuplica = <
  TError = ErrorType<WsProblema>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomandaIdAzioniDuplica>>,
    TError,
    { id: string; data: TipoDomandaDuplicaRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostTipiDomandaIdAzioniDuplicaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postTipiDomandaByIdsGruppiB2B = (
  postTipiDomandaByIdsGruppiB2BBody: string[],
  params?: PostTipiDomandaByIdsGruppiB2BParams,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<TipoDomandaDTO[]>(
    {
      url: `/framework-cfg-domande/tipi-domanda/byIdsGruppi/b2b`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: postTipiDomandaByIdsGruppiB2BBody,
      params,
    },
    options,
  );
};

export const getPostTipiDomandaByIdsGruppiB2BMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomandaByIdsGruppiB2B>>,
    TError,
    { data: string[]; params?: PostTipiDomandaByIdsGruppiB2BParams },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTipiDomandaByIdsGruppiB2B>>,
  TError,
  { data: string[]; params?: PostTipiDomandaByIdsGruppiB2BParams },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTipiDomandaByIdsGruppiB2B>>,
    { data: string[]; params?: PostTipiDomandaByIdsGruppiB2BParams }
  > = props => {
    const { data, params } = props ?? {};

    return postTipiDomandaByIdsGruppiB2B(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTipiDomandaByIdsGruppiB2BMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTipiDomandaByIdsGruppiB2B>>
>;
export type PostTipiDomandaByIdsGruppiB2BMutationBody = string[];
export type PostTipiDomandaByIdsGruppiB2BMutationError = ErrorType<unknown>;

export const usePostTipiDomandaByIdsGruppiB2B = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomandaByIdsGruppiB2B>>,
    TError,
    { data: string[]; params?: PostTipiDomandaByIdsGruppiB2BParams },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostTipiDomandaByIdsGruppiB2BMutationOptions(options);

  return useMutation(mutationOptions);
};
export const postTipiDomandaB2B = (
  postTipiDomandaB2BBody: string[],
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<TipoDomandaDTO[]>(
    {
      url: `/framework-cfg-domande/tipi-domanda/b2b`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: postTipiDomandaB2BBody,
    },
    options,
  );
};

export const getPostTipiDomandaB2BMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomandaB2B>>,
    TError,
    { data: string[] },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postTipiDomandaB2B>>,
  TError,
  { data: string[] },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postTipiDomandaB2B>>,
    { data: string[] }
  > = props => {
    const { data } = props ?? {};

    return postTipiDomandaB2B(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostTipiDomandaB2BMutationResult = NonNullable<
  Awaited<ReturnType<typeof postTipiDomandaB2B>>
>;
export type PostTipiDomandaB2BMutationBody = string[];
export type PostTipiDomandaB2BMutationError = ErrorType<unknown>;

export const usePostTipiDomandaB2B = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postTipiDomandaB2B>>,
    TError,
    { data: string[] },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostTipiDomandaB2BMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Verifica lo stato delle traduzioni dando per ogni lingua il numero delle traduzioni
 * @summary Stato traduzioni
 */
export const getTipiDomandaIdTraduzioniStato = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<StatoTraduzione[]>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}/traduzioni/stato`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetTipiDomandaIdTraduzioniStatoQueryKey = (id: string) =>
  [`/framework-cfg-domande/tipi-domanda/${id}/traduzioni/stato`] as const;

export const getGetTipiDomandaIdTraduzioniStatoQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiDomandaIdTraduzioniStato>>,
  TError = ErrorType<WsProblema>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaIdTraduzioniStato>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiDomandaIdTraduzioniStato>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTipiDomandaIdTraduzioniStatoQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiDomandaIdTraduzioniStato>>
  > = ({ signal }) =>
    getTipiDomandaIdTraduzioniStato(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetTipiDomandaIdTraduzioniStatoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiDomandaIdTraduzioniStato>>
>;
export type GetTipiDomandaIdTraduzioniStatoQueryError = ErrorType<WsProblema>;

/**
 * @summary Stato traduzioni
 */
export const useGetTipiDomandaIdTraduzioniStato = <
  TData = Awaited<ReturnType<typeof getTipiDomandaIdTraduzioniStato>>,
  TError = ErrorType<WsProblema>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaIdTraduzioniStato>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiDomandaIdTraduzioniStatoQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Permette il download di un file pubblico
 * @summary Recupera File Pubblico
 */
export const getTipiDomandaIdFilePubbliciPathNomeFile = (
  id: string,
  path: string,
  nomeFile: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Blob>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}/file-pubblici/${path}/${nomeFile}`,
      method: 'get',
      responseType: 'blob',
      signal,
    },
    options,
  );
};

export const getGetTipiDomandaIdFilePubbliciPathNomeFileQueryKey = (
  id: string,
  path: string,
  nomeFile: string,
) =>
  [
    `/framework-cfg-domande/tipi-domanda/${id}/file-pubblici/${path}/${nomeFile}`,
  ] as const;

export const getGetTipiDomandaIdFilePubbliciPathNomeFileQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiDomandaIdFilePubbliciPathNomeFile>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  path: string,
  nomeFile: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaIdFilePubbliciPathNomeFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiDomandaIdFilePubbliciPathNomeFile>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTipiDomandaIdFilePubbliciPathNomeFileQueryKey(id, path, nomeFile);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiDomandaIdFilePubbliciPathNomeFile>>
  > = ({ signal }) =>
    getTipiDomandaIdFilePubbliciPathNomeFile(
      id,
      path,
      nomeFile,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(id && path && nomeFile),
    ...queryOptions,
  };
};

export type GetTipiDomandaIdFilePubbliciPathNomeFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiDomandaIdFilePubbliciPathNomeFile>>
>;
export type GetTipiDomandaIdFilePubbliciPathNomeFileQueryError =
  ErrorType<unknown>;

/**
 * @summary Recupera File Pubblico
 */
export const useGetTipiDomandaIdFilePubbliciPathNomeFile = <
  TData = Awaited<ReturnType<typeof getTipiDomandaIdFilePubbliciPathNomeFile>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  path: string,
  nomeFile: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaIdFilePubbliciPathNomeFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiDomandaIdFilePubbliciPathNomeFileQueryOptions(
    id,
    path,
    nomeFile,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ottiene l'intersezione delle competenze di una tipoDomanda con il tipoProcedimento associato.
 * @summary Competenze TipoDomanda
 */
export const getTipiDomandaIdCompetenze = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Competenza[]>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}/competenze`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetTipiDomandaIdCompetenzeQueryKey = (id: string) =>
  [`/framework-cfg-domande/tipi-domanda/${id}/competenze`] as const;

export const getGetTipiDomandaIdCompetenzeQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiDomandaIdCompetenze>>,
  TError = ErrorType<WsProblema>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaIdCompetenze>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiDomandaIdCompetenze>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTipiDomandaIdCompetenzeQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiDomandaIdCompetenze>>
  > = ({ signal }) => getTipiDomandaIdCompetenze(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetTipiDomandaIdCompetenzeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiDomandaIdCompetenze>>
>;
export type GetTipiDomandaIdCompetenzeQueryError = ErrorType<WsProblema>;

/**
 * @summary Competenze TipoDomanda
 */
export const useGetTipiDomandaIdCompetenze = <
  TData = Awaited<ReturnType<typeof getTipiDomandaIdCompetenze>>,
  TError = ErrorType<WsProblema>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaIdCompetenze>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiDomandaIdCompetenzeQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Elenco campi estraibili geojson (campi fissi del tipo domanda, richiesta e campi di tipo metadato/campi semantici delle sezioni). Endpoint richiamato da cfg-domande: serve lista campi fissi + metadati in configurazione di una domanda da estrarre in geojson
 * @summary Elenco campi estraibili geojson (campi fissi del tipo domanda, richiesta e campi di tipo metadato/campi semantici delle sezioni)
 */
export const getTipiDomandaIdCampiGeojson = (
  id: string,
  params: GetTipiDomandaIdCampiGeojsonParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<CampoEstraibileCSV[]>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}/campi-geojson`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetTipiDomandaIdCampiGeojsonQueryKey = (
  id: string,
  params: GetTipiDomandaIdCampiGeojsonParams,
) =>
  [
    `/framework-cfg-domande/tipi-domanda/${id}/campi-geojson`,
    ...(params ? [params] : []),
  ] as const;

export const getGetTipiDomandaIdCampiGeojsonQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiDomandaIdCampiGeojson>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params: GetTipiDomandaIdCampiGeojsonParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaIdCampiGeojson>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiDomandaIdCampiGeojson>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTipiDomandaIdCampiGeojsonQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiDomandaIdCampiGeojson>>
  > = ({ signal }) =>
    getTipiDomandaIdCampiGeojson(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetTipiDomandaIdCampiGeojsonQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiDomandaIdCampiGeojson>>
>;
export type GetTipiDomandaIdCampiGeojsonQueryError = ErrorType<unknown>;

/**
 * @summary Elenco campi estraibili geojson (campi fissi del tipo domanda, richiesta e campi di tipo metadato/campi semantici delle sezioni)
 */
export const useGetTipiDomandaIdCampiGeojson = <
  TData = Awaited<ReturnType<typeof getTipiDomandaIdCampiGeojson>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params: GetTipiDomandaIdCampiGeojsonParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaIdCampiGeojson>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiDomandaIdCampiGeojsonQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Elenco campi estraibili csv (campi fissi del tipo domanda, richiesta e campi di tipo metadato/campi semantici delle sezioni). Endpoint richiamato da cfg-domande: serve lista campi fissi + metadati in configurazione di una domanda da estrarre in csv
 * @summary Elenco campi estraibili csv (campi fissi del tipo domanda, richiesta e campi di tipo metadato/campi semantici delle sezioni)
 */
export const getTipiDomandaIdCampiCsv = (
  id: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<CampoEstraibileCSV[]>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${id}/campi-csv`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetTipiDomandaIdCampiCsvQueryKey = (id: string) =>
  [`/framework-cfg-domande/tipi-domanda/${id}/campi-csv`] as const;

export const getGetTipiDomandaIdCampiCsvQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiDomandaIdCampiCsv>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaIdCampiCsv>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiDomandaIdCampiCsv>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTipiDomandaIdCampiCsvQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiDomandaIdCampiCsv>>
  > = ({ signal }) => getTipiDomandaIdCampiCsv(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetTipiDomandaIdCampiCsvQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiDomandaIdCampiCsv>>
>;
export type GetTipiDomandaIdCampiCsvQueryError = ErrorType<unknown>;

/**
 * @summary Elenco campi estraibili csv (campi fissi del tipo domanda, richiesta e campi di tipo metadato/campi semantici delle sezioni)
 */
export const useGetTipiDomandaIdCampiCsv = <
  TData = Awaited<ReturnType<typeof getTipiDomandaIdCampiCsv>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaIdCampiCsv>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiDomandaIdCampiCsvQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getTipiDomandaIdTipoDomandaCompetenzeUffici = (
  idTipoDomanda: string,
  params?: GetTipiDomandaIdTipoDomandaCompetenzeUfficiParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<UfficioCompetenzaDTO>(
    {
      url: `/framework-cfg-domande/tipi-domanda/${idTipoDomanda}/competenze/uffici`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetTipiDomandaIdTipoDomandaCompetenzeUfficiQueryKey = (
  idTipoDomanda: string,
  params?: GetTipiDomandaIdTipoDomandaCompetenzeUfficiParams,
) =>
  [
    `/framework-cfg-domande/tipi-domanda/${idTipoDomanda}/competenze/uffici`,
    ...(params ? [params] : []),
  ] as const;

export const getGetTipiDomandaIdTipoDomandaCompetenzeUfficiQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getTipiDomandaIdTipoDomandaCompetenzeUffici>
  >,
  TError = ErrorType<WsProblema>,
>(
  idTipoDomanda: string,
  params?: GetTipiDomandaIdTipoDomandaCompetenzeUfficiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaIdTipoDomandaCompetenzeUffici>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiDomandaIdTipoDomandaCompetenzeUffici>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTipiDomandaIdTipoDomandaCompetenzeUfficiQueryKey(
      idTipoDomanda,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiDomandaIdTipoDomandaCompetenzeUffici>>
  > = ({ signal }) =>
    getTipiDomandaIdTipoDomandaCompetenzeUffici(
      idTipoDomanda,
      params,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, enabled: !!idTipoDomanda, ...queryOptions };
};

export type GetTipiDomandaIdTipoDomandaCompetenzeUfficiQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getTipiDomandaIdTipoDomandaCompetenzeUffici>>
  >;
export type GetTipiDomandaIdTipoDomandaCompetenzeUfficiQueryError =
  ErrorType<WsProblema>;

export const useGetTipiDomandaIdTipoDomandaCompetenzeUffici = <
  TData = Awaited<
    ReturnType<typeof getTipiDomandaIdTipoDomandaCompetenzeUffici>
  >,
  TError = ErrorType<WsProblema>,
>(
  idTipoDomanda: string,
  params?: GetTipiDomandaIdTipoDomandaCompetenzeUfficiParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaIdTipoDomandaCompetenzeUffici>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetTipiDomandaIdTipoDomandaCompetenzeUfficiQueryOptions(
      idTipoDomanda,
      params,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Elenco tipiDomanda a partire da un tipo procedimento
 * @summary chiamata b2b. Elenco tipiDomanda a partire da un procedimento
 */
export const getTipiDomandaProcedimentoIdProcedimento = (
  idProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<TipoDomandaDTO[]>(
    {
      url: `/framework-cfg-domande/tipi-domanda/procedimento/${idProcedimento}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetTipiDomandaProcedimentoIdProcedimentoQueryKey = (
  idProcedimento: string,
) =>
  [
    `/framework-cfg-domande/tipi-domanda/procedimento/${idProcedimento}`,
  ] as const;

export const getGetTipiDomandaProcedimentoIdProcedimentoQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiDomandaProcedimentoIdProcedimento>>,
  TError = ErrorType<unknown>,
>(
  idProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaProcedimentoIdProcedimento>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiDomandaProcedimentoIdProcedimento>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTipiDomandaProcedimentoIdProcedimentoQueryKey(idProcedimento);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiDomandaProcedimentoIdProcedimento>>
  > = ({ signal }) =>
    getTipiDomandaProcedimentoIdProcedimento(
      idProcedimento,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, enabled: !!idProcedimento, ...queryOptions };
};

export type GetTipiDomandaProcedimentoIdProcedimentoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiDomandaProcedimentoIdProcedimento>>
>;
export type GetTipiDomandaProcedimentoIdProcedimentoQueryError =
  ErrorType<unknown>;

/**
 * @summary chiamata b2b. Elenco tipiDomanda a partire da un procedimento
 */
export const useGetTipiDomandaProcedimentoIdProcedimento = <
  TData = Awaited<ReturnType<typeof getTipiDomandaProcedimentoIdProcedimento>>,
  TError = ErrorType<unknown>,
>(
  idProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaProcedimentoIdProcedimento>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiDomandaProcedimentoIdProcedimentoQueryOptions(
    idProcedimento,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getTipiDomandaModuliSezioni = (
  params: GetTipiDomandaModuliSezioniParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<TipoDomandaModuloSezioneDTO>(
    {
      url: `/framework-cfg-domande/tipi-domanda/moduli/sezioni`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetTipiDomandaModuliSezioniQueryKey = (
  params: GetTipiDomandaModuliSezioniParams,
) =>
  [
    `/framework-cfg-domande/tipi-domanda/moduli/sezioni`,
    ...(params ? [params] : []),
  ] as const;

export const getGetTipiDomandaModuliSezioniQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiDomandaModuliSezioni>>,
  TError = ErrorType<unknown>,
>(
  params: GetTipiDomandaModuliSezioniParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaModuliSezioni>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiDomandaModuliSezioni>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTipiDomandaModuliSezioniQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiDomandaModuliSezioni>>
  > = ({ signal }) =>
    getTipiDomandaModuliSezioni(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetTipiDomandaModuliSezioniQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiDomandaModuliSezioni>>
>;
export type GetTipiDomandaModuliSezioniQueryError = ErrorType<unknown>;

export const useGetTipiDomandaModuliSezioni = <
  TData = Awaited<ReturnType<typeof getTipiDomandaModuliSezioni>>,
  TError = ErrorType<unknown>,
>(
  params: GetTipiDomandaModuliSezioniParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaModuliSezioni>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiDomandaModuliSezioniQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getTipiDomandaDifferenzeVersioni = (
  params: GetTipiDomandaDifferenzeVersioniParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<ConfrontoVersioniResponse>(
    {
      url: `/framework-cfg-domande/tipi-domanda/differenze-versioni`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetTipiDomandaDifferenzeVersioniQueryKey = (
  params: GetTipiDomandaDifferenzeVersioniParams,
) =>
  [
    `/framework-cfg-domande/tipi-domanda/differenze-versioni`,
    ...(params ? [params] : []),
  ] as const;

export const getGetTipiDomandaDifferenzeVersioniQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiDomandaDifferenzeVersioni>>,
  TError = ErrorType<unknown>,
>(
  params: GetTipiDomandaDifferenzeVersioniParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaDifferenzeVersioni>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiDomandaDifferenzeVersioni>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTipiDomandaDifferenzeVersioniQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiDomandaDifferenzeVersioni>>
  > = ({ signal }) =>
    getTipiDomandaDifferenzeVersioni(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetTipiDomandaDifferenzeVersioniQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiDomandaDifferenzeVersioni>>
>;
export type GetTipiDomandaDifferenzeVersioniQueryError = ErrorType<unknown>;

export const useGetTipiDomandaDifferenzeVersioni = <
  TData = Awaited<ReturnType<typeof getTipiDomandaDifferenzeVersioni>>,
  TError = ErrorType<unknown>,
>(
  params: GetTipiDomandaDifferenzeVersioniParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaDifferenzeVersioni>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiDomandaDifferenzeVersioniQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getTipiDomandaCountCompetenzeInTipoDomandaIdCompetenza = (
  idCompetenza: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<number>(
    {
      url: `/framework-cfg-domande/tipi-domanda/count-competenze-in-tipo-domanda/${idCompetenza}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetTipiDomandaCountCompetenzeInTipoDomandaIdCompetenzaQueryKey =
  (idCompetenza: string) =>
    [
      `/framework-cfg-domande/tipi-domanda/count-competenze-in-tipo-domanda/${idCompetenza}`,
    ] as const;

export const getGetTipiDomandaCountCompetenzeInTipoDomandaIdCompetenzaQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getTipiDomandaCountCompetenzeInTipoDomandaIdCompetenza>
    >,
    TError = ErrorType<unknown>,
  >(
    idCompetenza: string,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTipiDomandaCountCompetenzeInTipoDomandaIdCompetenza
          >
        >,
        TError,
        TData
      >;
      request?: SecondParameter<typeof apiClientRequest>;
    },
  ): UseQueryOptions<
    Awaited<
      ReturnType<typeof getTipiDomandaCountCompetenzeInTipoDomandaIdCompetenza>
    >,
    TError,
    TData
  > & { queryKey: QueryKey } => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTipiDomandaCountCompetenzeInTipoDomandaIdCompetenzaQueryKey(
        idCompetenza,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getTipiDomandaCountCompetenzeInTipoDomandaIdCompetenza
        >
      >
    > = ({ signal }) =>
      getTipiDomandaCountCompetenzeInTipoDomandaIdCompetenza(
        idCompetenza,
        requestOptions,
        signal,
      );

    return { queryKey, queryFn, enabled: !!idCompetenza, ...queryOptions };
  };

export type GetTipiDomandaCountCompetenzeInTipoDomandaIdCompetenzaQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getTipiDomandaCountCompetenzeInTipoDomandaIdCompetenza>
    >
  >;
export type GetTipiDomandaCountCompetenzeInTipoDomandaIdCompetenzaQueryError =
  ErrorType<unknown>;

export const useGetTipiDomandaCountCompetenzeInTipoDomandaIdCompetenza = <
  TData = Awaited<
    ReturnType<typeof getTipiDomandaCountCompetenzeInTipoDomandaIdCompetenza>
  >,
  TError = ErrorType<unknown>,
>(
  idCompetenza: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getTipiDomandaCountCompetenzeInTipoDomandaIdCompetenza
        >
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetTipiDomandaCountCompetenzeInTipoDomandaIdCompetenzaQueryOptions(
      idCompetenza,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ottiene una tipoDomanda tramite il codice.
 * @summary TipoDomanda tramite codice.
 */
export const getTipiDomandaCodiceCodice = (
  codice: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<TipoDomandaDTO>(
    {
      url: `/framework-cfg-domande/tipi-domanda/codice/${codice}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetTipiDomandaCodiceCodiceQueryKey = (codice: string) =>
  [`/framework-cfg-domande/tipi-domanda/codice/${codice}`] as const;

export const getGetTipiDomandaCodiceCodiceQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiDomandaCodiceCodice>>,
  TError = ErrorType<WsProblema>,
>(
  codice: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaCodiceCodice>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiDomandaCodiceCodice>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTipiDomandaCodiceCodiceQueryKey(codice);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiDomandaCodiceCodice>>
  > = ({ signal }) =>
    getTipiDomandaCodiceCodice(codice, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!codice, ...queryOptions };
};

export type GetTipiDomandaCodiceCodiceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiDomandaCodiceCodice>>
>;
export type GetTipiDomandaCodiceCodiceQueryError = ErrorType<WsProblema>;

/**
 * @summary TipoDomanda tramite codice.
 */
export const useGetTipiDomandaCodiceCodice = <
  TData = Awaited<ReturnType<typeof getTipiDomandaCodiceCodice>>,
  TError = ErrorType<WsProblema>,
>(
  codice: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaCodiceCodice>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiDomandaCodiceCodiceQueryOptions(
    codice,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getTipiDomandaByIdsGruppiInCollaudo = (
  inCollaudo: boolean,
  params: GetTipiDomandaByIdsGruppiInCollaudoParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<TipoDomandaDTO[]>(
    {
      url: `/framework-cfg-domande/tipi-domanda/byIdsGruppi/${inCollaudo}`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetTipiDomandaByIdsGruppiInCollaudoQueryKey = (
  inCollaudo: boolean,
  params: GetTipiDomandaByIdsGruppiInCollaudoParams,
) =>
  [
    `/framework-cfg-domande/tipi-domanda/byIdsGruppi/${inCollaudo}`,
    ...(params ? [params] : []),
  ] as const;

export const getGetTipiDomandaByIdsGruppiInCollaudoQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiDomandaByIdsGruppiInCollaudo>>,
  TError = ErrorType<WsProblema>,
>(
  inCollaudo: boolean,
  params: GetTipiDomandaByIdsGruppiInCollaudoParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaByIdsGruppiInCollaudo>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiDomandaByIdsGruppiInCollaudo>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTipiDomandaByIdsGruppiInCollaudoQueryKey(inCollaudo, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiDomandaByIdsGruppiInCollaudo>>
  > = ({ signal }) =>
    getTipiDomandaByIdsGruppiInCollaudo(
      inCollaudo,
      params,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, enabled: !!inCollaudo, ...queryOptions };
};

export type GetTipiDomandaByIdsGruppiInCollaudoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiDomandaByIdsGruppiInCollaudo>>
>;
export type GetTipiDomandaByIdsGruppiInCollaudoQueryError =
  ErrorType<WsProblema>;

export const useGetTipiDomandaByIdsGruppiInCollaudo = <
  TData = Awaited<ReturnType<typeof getTipiDomandaByIdsGruppiInCollaudo>>,
  TError = ErrorType<WsProblema>,
>(
  inCollaudo: boolean,
  params: GetTipiDomandaByIdsGruppiInCollaudoParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaByIdsGruppiInCollaudo>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiDomandaByIdsGruppiInCollaudoQueryOptions(
    inCollaudo,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ottiene i dettagli di una tipoDomanda.
 * @summary Dettaglio TipoDomanda
 */
export const getTipiDomandaByIdGruppoIdGruppo = (
  idGruppo: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<TipoDomandaDTO>(
    {
      url: `/framework-cfg-domande/tipi-domanda/byIdGruppo/${idGruppo}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetTipiDomandaByIdGruppoIdGruppoQueryKey = (idGruppo: string) =>
  [`/framework-cfg-domande/tipi-domanda/byIdGruppo/${idGruppo}`] as const;

export const getGetTipiDomandaByIdGruppoIdGruppoQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiDomandaByIdGruppoIdGruppo>>,
  TError = ErrorType<WsProblema>,
>(
  idGruppo: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaByIdGruppoIdGruppo>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiDomandaByIdGruppoIdGruppo>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTipiDomandaByIdGruppoIdGruppoQueryKey(idGruppo);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiDomandaByIdGruppoIdGruppo>>
  > = ({ signal }) =>
    getTipiDomandaByIdGruppoIdGruppo(idGruppo, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!idGruppo, ...queryOptions };
};

export type GetTipiDomandaByIdGruppoIdGruppoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiDomandaByIdGruppoIdGruppo>>
>;
export type GetTipiDomandaByIdGruppoIdGruppoQueryError = ErrorType<WsProblema>;

/**
 * @summary Dettaglio TipoDomanda
 */
export const useGetTipiDomandaByIdGruppoIdGruppo = <
  TData = Awaited<ReturnType<typeof getTipiDomandaByIdGruppoIdGruppo>>,
  TError = ErrorType<WsProblema>,
>(
  idGruppo: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaByIdGruppoIdGruppo>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiDomandaByIdGruppoIdGruppoQueryOptions(
    idGruppo,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ritorna l'elenco delle tipoDomande comprensive di quelle di sistema.
 * @summary Elenco TipoDomande anche quelle di sistema
 */
export const getTipiDomandaB2BSearch = (
  params?: GetTipiDomandaB2BSearchParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<WsRispostaPaginataListTipoDomandaDTO>(
    {
      url: `/framework-cfg-domande/tipi-domanda/b2b/search`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetTipiDomandaB2BSearchQueryKey = (
  params?: GetTipiDomandaB2BSearchParams,
) =>
  [
    `/framework-cfg-domande/tipi-domanda/b2b/search`,
    ...(params ? [params] : []),
  ] as const;

export const getGetTipiDomandaB2BSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiDomandaB2BSearch>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTipiDomandaB2BSearchParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaB2BSearch>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiDomandaB2BSearch>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTipiDomandaB2BSearchQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiDomandaB2BSearch>>
  > = ({ signal }) => getTipiDomandaB2BSearch(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetTipiDomandaB2BSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiDomandaB2BSearch>>
>;
export type GetTipiDomandaB2BSearchQueryError = ErrorType<unknown>;

/**
 * @summary Elenco TipoDomande anche quelle di sistema
 */
export const useGetTipiDomandaB2BSearch = <
  TData = Awaited<ReturnType<typeof getTipiDomandaB2BSearch>>,
  TError = ErrorType<unknown>,
>(
  params?: GetTipiDomandaB2BSearchParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getTipiDomandaB2BSearch>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiDomandaB2BSearchQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ritorna l'elenco delle Aree dei TipiDomande.
 * @summary Elenco Aree TipiDomande
 */
export const getTipiDomandaAree = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<AreeDTO[]>(
    { url: `/framework-cfg-domande/tipi-domanda/aree`, method: 'get', signal },
    options,
  );
};

export const getGetTipiDomandaAreeQueryKey = () =>
  [`/framework-cfg-domande/tipi-domanda/aree`] as const;

export const getGetTipiDomandaAreeQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiDomandaAree>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTipiDomandaAree>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiDomandaAree>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTipiDomandaAreeQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTipiDomandaAree>>
  > = ({ signal }) => getTipiDomandaAree(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetTipiDomandaAreeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiDomandaAree>>
>;
export type GetTipiDomandaAreeQueryError = ErrorType<unknown>;

/**
 * @summary Elenco Aree TipiDomande
 */
export const useGetTipiDomandaAree = <
  TData = Awaited<ReturnType<typeof getTipiDomandaAree>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTipiDomandaAree>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiDomandaAreeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
